import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  descricao: '',
  classe_cnae: [],
  codigo: '',
  ativo: null,
};

export const AtividadeEntidadeContext = createContext();

export const AtividadeEntidadeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [atividadeEntidade, setAtividadeEntidade] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getAtividadeEntidade = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: atividadeEntidade?.filter,
        page: atividadeEntidade?.page,
        size: atividadeEntidade?.size,
        order: atividadeEntidade?.order,
        ...payload,
      });
      setAtividadeEntidade((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <AtividadeEntidadeContext.Provider
      value={{
        getLoading,
        atividadeEntidade,
        getAtividadeEntidade,
      }}
    >
      {children}
    </AtividadeEntidadeContext.Provider>
  );
};
